export interface NavBadge {
  count: number;
  /** "attention" means someone is waiting on the venue (pending bookings, new orders). */
  tone: "attention" | "info";
  label: string;
}

export function NavBadgeChip({ badge }: { badge: NavBadge | undefined }) {
  if (!badge) return null;
  return (
    <span aria-label={badge.label} className="provider-nav-badge" data-tone={badge.tone} title={badge.label}>
      {badge.count > 99 ? "99+" : badge.count}
    </span>
  );
}
